import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = (): JSX.Element => (
  <div>
    <h1>404 - Not Found!</h1>
    <Link to="/orders">Go to Orders</Link>
  </div>
);

export default NotFound;
